module.exports = __webpack_public_path__ + "static/media/who.1676b1c0.jpg";